import PropTypes from 'prop-types';
import React from 'react';
import alphabet from 'alphabet';
import SplitLayout from '../common/layouts/splitLayout';
import AudioContainer from '../common/audio/audioContainer';
import StimulusButton from '../common/stimulus/StimulusButton';
import LetterButtonGrid from '../common/components/LetterButtonGrid';
import GoButton from '../common/components/GoButton';
import ScreenErrorContainer from '../common/error/ScreenErrorContainer';

class LNView extends React.Component {
    componentDidMount() {
        if (!this.props.isDataFetched) {
            this.props.fetchContent();
        } else {
            this.props.narrateScreen(this.props.stimulus);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isDataFetched && this.narrationShouldStart(prevProps)) {
            this.props.narrateScreen(this.props.stimulus);
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    getStimulusArea() {
        return (
            <div>
                <StimulusButton
                    isDisabled={this.props.isGreyedOut}
                    isPlaying={this.props.isStimulusPlaying}
                    onClick={this.playStimulus} />
            </div>
        );
    }

    getAlphabetArray() {
        if (this.props.questionIndex <= this.props.totalQuestions / 2) {
            return alphabet.upper;
        }
        return alphabet.lower;
    }

    getResponsesArea() {
        const alphabetCase = this.getAlphabetArray();
        return (
            <LetterButtonGrid
                buttons={[...alphabetCase]}
                selectedIndex={this.props.selectedIndex}
                enabledButtons={this.props.enabledResponses}
                isEnabled={this.props.isButtonGridEnabled}
                onButtonClick={this.props.selectResponse}
                isDisabled={this.props.isGreyedOut}
            />
        );
    }

    playStimulus = () => {
        if (this.props.stimulus.audio) {
            this.props.narrateStimulus(this.props.stimulus.audio, 0);
        }
    };

    narrationShouldStart(prevProps) {
        const isReady = this.props.isDataFetched;
        const shouldStartNarrate = (
            this.props.isDataFetched !== prevProps.isDataFetched
            || this.props.questionIndex !== prevProps.questionIndex
        );
        return isReady && shouldStartNarrate;
    }

    handleOnNext() {
        return () => {
            this.props.selectResponse(this.props.selectedIndex);
        };
    }

    render() {
        return (
            <SplitLayout
                upperElement={this.getStimulusArea()}
                lowerElement={this.getResponsesArea()}
                isScreenBlocked={this.props.isScreenBlocked}
                isGreyedOut={this.props.isGreyedOut}>
                {this.props.isNextButtonVisible
                    && (
                        <GoButton
                            onClick={this.props.onNext}
                            isEnabled={!this.props.isScreenBlocked} />
                    )}
                <ScreenErrorContainer onRetry={this.handleOnNext()} />
                <AudioContainer />
            </SplitLayout>
        );
    }
}

export default LNView;

LNView.propTypes = {
    narrateStimulus: PropTypes.func,
    isStimulusPlaying: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isNextButtonVisible: PropTypes.bool,
    questionIndex: PropTypes.number,
    totalQuestions: PropTypes.number,
    selectedIndex: PropTypes.string,
    cleanup: PropTypes.func,
    selectResponse: PropTypes.func.isRequired,
    isDataFetched: PropTypes.bool,
    onNext: PropTypes.func,
    fetchContent: PropTypes.func.isRequired,
    isGreyedOut: PropTypes.bool,
    isButtonGridEnabled: PropTypes.bool,
    narrateScreen: PropTypes.func.isRequired,
    stimulus: PropTypes.object,
    enabledResponses: PropTypes.array,
};

LNView.defaultProps = {
    isStimulusPlaying: false,
    isScreenBlocked: false,
    questionIndex: undefined,
    selectedIndex: undefined,
    isNextButtonVisible: false,
    isButtonGridEnabled: true,
    isGreyedOut: false,
    isDataFetched: false,
    totalQuestions: undefined,
    enabledResponses: [],
    stimulus: {},
    narrateStimulus: () => {},
    onNext: () => {},
    cleanup: () => {},
};
